import { Link as RouterLink, useMatches } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { ROUTES } from '@/constants/routes.constants';

export interface RouteBreadcrumbHandle {
  breadcrumb?: string | string[];
}

export function Breadcrumbs() {
  const { t } = useTranslation();
  const matches = useMatches();

  const current = [...matches]
    .reverse()
    .find((match) => (match.handle as RouteBreadcrumbHandle | undefined)?.breadcrumb);

  const breadcrumb = (current?.handle as RouteBreadcrumbHandle | undefined)?.breadcrumb;

  if (!breadcrumb) return null;

  const labels = Array.isArray(breadcrumb) ? breadcrumb : [breadcrumb];
  const isDashboard = current?.pathname === ROUTES.DASHBOARD;

  return (
    <MuiBreadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ fontSize: 14 }}>
      {!isDashboard && (
        <Link
          component={RouterLink}
          to={ROUTES.DASHBOARD}
          underline="hover"
          color="inherit"
          variant="body2"
        >
          <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
            <HomeOutlinedIcon fontSize="inherit" />
            <span>{t('nav.dashboard')}</span>
          </Stack>
        </Link>
      )}
      {labels.map((label, index) => {
        const isLast = index === labels.length - 1;
        return (
          <Typography
            key={label}
            variant="body2"
            color={isLast ? 'text.primary' : 'text.secondary'}
            sx={{ fontWeight: isLast ? 600 : 400 }}
          >
            {t(label)}
          </Typography>
        );
      })}
    </MuiBreadcrumbs>
  );
}
